import { render, staticRenderFns } from "./commercialListItemTwo.vue?vue&type=template&id=4858ad72&scoped=true"
import script from "./commercialListItemTwo.vue?vue&type=script&lang=js"
export * from "./commercialListItemTwo.vue?vue&type=script&lang=js"
import style0 from "./commercialListItemTwo.vue?vue&type=style&index=0&id=4858ad72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4858ad72",
  null
  
)

export default component.exports